import { render, staticRenderFns } from "./PaymentTypeSegment.vue?vue&type=template&id=499b17a6"
import script from "./PaymentTypeSegment.vue?vue&type=script&lang=js"
export * from "./PaymentTypeSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports